var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('editor',{attrs:{"initial":_vm.dataItem,"backUrl":_vm.backUrl,"docTitle":_vm.docTitle,"noTitle":_vm.noTitle}}),_c('snackbar',{ref:"snackbar"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }